import { useEffect, useState } from "react";
import { Loader2, ShieldAlert } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { IronDivider } from "@/components/common/Ornament";
import { toast } from "sonner";

export default function DisclaimerGate() {
  const { acknowledge, logout } = useAuth();
  const [data, setData] = useState(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/disclaimer").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const go = async () => {
    setBusy(true);
    try { await acknowledge(); } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 iron-pattern overflow-y-auto flex items-start sm:items-center justify-center p-4 sm:p-8" data-testid="disclaimer-gate">
      <div className="w-full max-w-3xl bg-[#F9F6F0] rounded-lg shadow-2xl p-6 sm:p-10 corner-frame fade-up">
        <div className="flex items-center gap-3">
          <ShieldAlert className="h-6 w-6 text-[#C59B27]" />
          <p className="eyebrow">Required Before Entry</p>
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#0F2E23] mt-3">Important Notice</h1>
        <p className="text-sm text-slate-600 mt-1">{data?.project_name}</p>
        <IronDivider className="my-6" />
        <div className="max-h-[45vh] overflow-y-auto pr-2 text-[0.95rem] leading-relaxed text-slate-800 whitespace-pre-line" data-testid="disclaimer-scroll-container">
          {data ? data.text : <Loader2 className="h-5 w-5 animate-spin text-[#C59B27]" />}
        </div>
        <label className="mt-8 flex items-start gap-3 cursor-pointer rounded-md border border-[#E2DCD2] bg-white p-4" data-testid="disclaimer-checkbox-label">
          <Checkbox checked={checked} onCheckedChange={(v) => setChecked(!!v)} className="mt-0.5" data-testid="disclaimer-checkbox" />
          <span className="text-sm font-medium text-[#0F2E23]">I have read and understand this disclaimer</span>
        </label>
        <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-between gap-3">
          <button onClick={logout} className="h-11 px-5 rounded-md text-sm text-slate-600 hover:text-[#0F2E23]" data-testid="disclaimer-logout-btn">Log out</button>
          <button
            onClick={go} disabled={!checked || busy || !data}
            className="h-11 px-8 rounded-md bg-[#0F2E23] text-[#F9F6F0] font-semibold hover:bg-[#164032] disabled:opacity-40 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-2"
            data-testid="disclaimer-continue-btn"
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Continue
          </button>
        </div>
      </div>
    </div>
  );
}
